<script setup lang="ts">
import { defineEmits, defineProps } from 'vue'

const props = defineProps({
  isLoading: Boolean,
  label: {
    type: String,
    default: 'Entrar',
  },
})

const emit = defineEmits(['submit'])

function handleSubmit() {
  emit('submit')
}
</script>

<template>
  <button
    @click="handleSubmit"
    :disabled="props.isLoading"
    class="flex w-28 cursor-pointer justify-center border border-primary bg-primary p-2 font-medium text-white transition hover:bg-opacity-90">
    <div class="flex flex-row items-center text-center">
      <div v-if="isLoading" class="animate-spin items-center">
        <!-- Icone de Loading -->
        <svg class="h-7 w-7 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
      <span v-else class="flex items-center justify-center">
        {{ label }}
      </span>
    </div>
  </button>
</template>
